var I = Object.defineProperty;
var C = (t, e, n) => e in t ? I(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var l = (t, e, n) => (C(t, typeof e != "symbol" ? e + "" : e, n), n);
const S = "cookie_consent";
function $(t) {
  const e = t.split(";").map((o) => o.split("=").map((a) => a.trim())).find(([o]) => o === S);
  if (!e)
    return null;
  const [, n] = e;
  return n !== "0" && n !== "1" ? (console.warn("cookie_consent: unexpected cookie value"), null) : n;
}
let v = !1;
const G = "cookie-consent:accepted";
function M() {
  return L(z());
}
function x(t) {
  v && console.warn(
    "already called whenAllowed on cookie-consent, did you initialize google analytics twice ?"
  ), M() ? (w("whenAllowed, has consent"), t()) : (w("whenAllowed, has not consent, wait"), v = !0, window.addEventListener(G, () => {
    w("consent accepted"), t();
  }));
}
function L(t) {
  return t === "1";
}
function w(t) {
  var e;
  (e = window == null ? void 0 : window.config) != null && e.cookie_consent_debug && console.log(`cookie-consent: ${t}`);
}
function z() {
  return $(document.cookie);
}
function O(t) {
  return t.isAuthenticated && t.roles.includes("teacher");
}
function T(t) {
  return t.isAuthenticated && t.trialState === "NORMAL_USER" && t.roles.includes("student");
}
const A = (...t) => {
  typeof window < "u" && (typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
    window.dataLayer.push(arguments);
  }), window.gtag(...t));
};
class q {
  constructor() {
    l(this, "reset", () => {
      this.isInitialized = !1, this._testMode = !1, this._currentMeasurementId, this._hasLoadedGA = !1, this._isQueuing = !1, this._queueGtag = [];
    });
    l(this, "_gtag", (...e) => {
      this._testMode ? this._queueGtag.push(e) : this._isQueuing ? this._queueGtag.push(e) : A(...e);
    });
    l(this, "_loadGA", (e, n) => {
      if (!(typeof window > "u" || typeof document > "u") && !this._hasLoadedGA) {
        const o = document.createElement("script");
        o.async = !0, o.src = `https://www.googletagmanager.com/gtag/js?id=${e}`, n && o.setAttribute("nonce", n), document.body.appendChild(o), window.dataLayer = window.dataLayer || [], window.gtag = function() {
          window.dataLayer.push(arguments);
        }, this._hasLoadedGA = !0;
      }
    });
    l(this, "_toGtagOptions", (e) => {
      if (!e)
        return;
      const n = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      return Object.entries(e).reduce((a, [s, u]) => (n[s] ? a[n[s]] = u : a[s] = u, a), {});
    });
    /**
     *
     * @param {InitOptions[]|string} GA_MEASUREMENT_ID
     * @param {Object} [options]
     * @param {string} [options.nonce]
     * @param {boolean} [options.testMode=false]
     * @param {GaOptions|any} [options.gaOptions]
     * @param {Object} [options.gtagOptions] New parameter
     */
    l(this, "initialize", (e, n = {}) => {
      if (!e)
        throw new Error("Require GA_MEASUREMENT_ID");
      const o = typeof e == "string" ? [{ trackingId: e }] : e;
      this._currentMeasurementId = o[0].trackingId;
      const { gaOptions: a, gtagOptions: s, nonce: u, testMode: d = !1 } = n;
      if (this._testMode = d, d || this._loadGA(this._currentMeasurementId, u), this.isInitialized || (this._gtag("js", /* @__PURE__ */ new Date()), o.forEach((i) => {
        const r = {
          ...this._toGtagOptions({ ...a, ...i.gaOptions }),
          ...s,
          ...i.gtagOptions
        };
        Object.keys(r).length ? this._gtag("config", i.trackingId, r) : this._gtag("config", i.trackingId);
      })), this.isInitialized = !0, !d) {
        const i = [...this._queueGtag];
        for (this._queueGtag = [], this._isQueuing = !1; i.length; ) {
          const r = i.shift();
          this._gtag(...r), r[0] === "get" && (this._isQueuing = !0);
        }
      }
    });
    l(this, "set", (e) => {
      if (!e) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (typeof e != "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      Object.keys(e).length === 0 && console.warn("empty `fieldsObject` given to .set()"), this._gaCommand("set", e);
    });
    l(this, "_gaCommandSendEvent", (e, n, o, a, s) => {
      this._gtag("event", n, {
        event_category: e,
        event_label: o,
        value: a,
        ...s && { non_interaction: s.nonInteraction },
        ...this._toGtagOptions(s)
      });
    });
    l(this, "_gaCommandSendEventParameters", (...e) => {
      if (typeof e[0] == "string")
        this._gaCommandSendEvent(...e.slice(1));
      else {
        const { eventCategory: n, eventAction: o, eventLabel: a, eventValue: s, hitType: u, ...d } = e[0];
        this._gaCommandSendEvent(n, o, a, s, d);
      }
    });
    l(this, "_gaCommandSendTiming", (e, n, o, a) => {
      this._gtag("event", "timing_complete", {
        name: n,
        value: o,
        event_category: e,
        event_label: a
      });
    });
    l(this, "_gaCommandSendPageview", (e, n) => {
      if (n && Object.keys(n).length) {
        const { title: o, location: a, ...s } = this._toGtagOptions(n);
        this._gtag("event", "page_view", {
          ...e && { page_path: e },
          ...o && { page_title: o },
          ...a && { page_location: a },
          ...s
        });
      } else
        e ? this._gtag("event", "page_view", { page_path: e }) : this._gtag("event", "page_view");
    });
    l(this, "_gaCommandSendPageviewParameters", (...e) => {
      if (typeof e[0] == "string")
        this._gaCommandSendPageview(...e.slice(1));
      else {
        const { page: n, hitType: o, ...a } = e[0];
        this._gaCommandSendPageview(n, a);
      }
    });
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/command-queue-reference#send
    l(this, "_gaCommandSend", (...e) => {
      const n = typeof e[0] == "string" ? e[0] : e[0].hitType;
      switch (n) {
        case "event":
          this._gaCommandSendEventParameters(...e);
          break;
        case "pageview":
          this._gaCommandSendPageviewParameters(...e);
          break;
        case "timing":
          this._gaCommandSendTiming(...e.slice(1));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn(`Unsupported send command: ${n}`);
          break;
        default:
          console.warn(`Send command doesn't exist: ${n}`);
      }
    });
    l(this, "_gaCommandSet", (...e) => {
      typeof e[0] == "string" && (e[0] = { [e[0]]: e[1] }), this._gtag("set", this._toGtagOptions(e[0]));
    });
    l(this, "_gaCommand", (e, ...n) => {
      switch (e) {
        case "send":
          this._gaCommandSend(...n);
          break;
        case "set":
          this._gaCommandSet(...n);
          break;
        default:
          console.warn(`Command doesn't exist: ${e}`);
      }
    });
    l(this, "ga", (...e) => {
      if (typeof e[0] == "string")
        this._gaCommand(...e);
      else {
        const [n] = e;
        this._gtag("get", this._currentMeasurementId, "client_id", (o) => {
          this._isQueuing = !1;
          const a = this._queueGtag;
          for (n({
            get: (s) => s === "clientId" ? o : s === "trackingId" ? this._currentMeasurementId : s === "apiVersion" ? "1" : void 0
          }); a.length; ) {
            const s = a.shift();
            this._gtag(...s);
          }
        }), this._isQueuing = !0;
      }
      return this.ga;
    });
    /**
     * @param {UaEventOptions|string} optionsOrName
     * @param {Object} [params]
     */
    l(this, "event", (e, n) => {
      if (typeof e == "string")
        this._gtag("event", e, this._toGtagOptions(n));
      else {
        const { action: o, category: a, label: s, value: u, nonInteraction: d, transport: i } = e;
        if (!a || !o) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }
        const r = {
          hitType: "event",
          eventCategory: a,
          eventAction: o
        };
        s && (r.eventLabel = s), typeof u < "u" && (typeof u != "number" ? console.warn("Expected `args.value` arg to be a Number.") : r.eventValue = u), typeof d < "u" && (typeof d != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : r.nonInteraction = d), typeof i < "u" && (typeof i != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(i) === -1 && console.warn(
          "`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"
        ), r.transport = i)), this._gaCommand("send", r);
      }
    });
    l(this, "send", (e) => {
      this._gaCommand("send", e);
    });
    this.reset();
  }
  gtag(...e) {
    this._gtag(...e);
  }
}
const m = new q();
function y(t, e) {
  const n = t.split(";").map((s) => s.split("=").map((u) => u.trim())).find(([s]) => s === e);
  if (!n)
    return !1;
  const [, o] = n;
  if (o !== "false" && o !== "true")
    return console.warn(`${e}: unexpected cookie value`), !1;
  const a = o === "true";
  return a && console.log(`${e} enabled`), a;
}
function P() {
  const t = y(document.cookie, "ga4_test_mode"), e = y(document.cookie, "ga4_debug"), n = y(document.cookie, "ga4_trace");
  return { debug: e, trace: n, testMode: t };
}
const b = () => ({
  initialized: !1,
  debug: !1,
  trace: !1,
  testMode: !1,
  appName: "unknown",
  gaMeasurementId: "",
  schoolType: "",
  userId: "",
  userRole: "",
  userTrial: "",
  env: ""
});
function E(t) {
  if (t.env)
    return t.env;
  const { host: e } = window.location;
  return e === "gleerupsportal.se" ? "prod" : e === "stage.eedev.se" ? "stage" : e === "chi.eedev.se" ? "chi" : "dev";
}
const V = {
  dev: "",
  chi: "G-LC9PSYEXJY",
  stage: "G-66D873MRQJ",
  prod: "G-XT26MXHLY4"
};
function R(t) {
  return O(t) ? "teacher" : T(t) ? "student" : t.roles[0] || "unknown";
}
function j() {
  const t = b();
  function e(i, r) {
    t.trace && (r ? console.log(`analytics ${t.appName}: ${i}`, r) : console.log(`analytics ${t.appName}: ${i}`));
  }
  function n(i) {
    if (t.initialized) {
      e("analytics.init already initialized");
      return;
    }
    const { debug: r, trace: g, testMode: p } = P();
    t.debug = r || i.debug || !1, t.trace = g || i.trace || !1, t.appName = i.appName, t.testMode = p || i.testMode || !1;
    const f = E(i);
    if (t.env = f, t.gaMeasurementId = V[f], !t.gaMeasurementId) {
      e("missing gaMeasurementId, skip google analytics");
      return;
    }
    e("analytics.init, wait for cookie consent"), t.testMode && (window.ReactGA = m), x(() => {
      if (t.initialized) {
        e("analytics.init already initialized after cookie approve");
        return;
      }
      e("analytics.init calling"), m.initialize(t.gaMeasurementId, {
        gaOptions: {
          cookie_flags: "SameSite=Lax"
          // see CONX-1435
        },
        testMode: t.testMode
      }), t.initialized = !0, e("analytics.init done");
    });
  }
  function o(i) {
    const r = R(i), g = i.trialState.toLowerCase();
    t.userId === i.userId && t.userRole === r && t.userTrial === g || (e(`setUser id: "${i.userId}" role: "${r}" trial: "${g}"`), m.gtag("set", "user_properties", {
      user_role: r,
      user_id: i.userId,
      user_trial: g
    }), t.userId = i.userId, t.userRole = r, t.userTrial = g);
  }
  function a(i) {
    t.schoolType !== i && (e(`setSchoolType: "${i}", (prev: "${t.schoolType}")`), m.gtag("set", "user_properties", { user_school_type: i }), t.schoolType = i);
  }
  function s() {
    e("reset"), m.reset();
  }
  function u(i) {
    const g = /^\S*$/, p = /^[_a-z0-9.]*$/;
    let f = !0;
    const k = ["action", "category", "label"];
    return Object.entries(i).forEach(([_, h]) => {
      if (k.includes(_)) {
        if (!(h != null && h.length)) {
          _ !== "label" && (console.warn(`Value of '${_}' is missing`, i), f = !1);
          return;
        }
        if (h.length > 40 && (console.warn(
          `Value of '${_}' exceeds maximum length of 40 characters.`,
          i
        ), f = !1), !g.test(h)) {
          console.warn(`Value of '${_}' contains whitespace ('${h}')`, i), f = !1;
          return;
        }
        p.test(h) || (console.warn(
          `Value of '${_}' is not lowercase or invalid character ('${h}')`,
          i
        ), f = !1);
      }
    }), f;
  }
  function d(i) {
    if (!u(i))
      return;
    const { action: r } = i, g = Object.fromEntries(
      Object.entries(i).filter(([p]) => p !== "action").map(([p, f]) => [`event_${p}`, f])
    );
    e(`send ga event: "${r}"`, i), m.event(r, g);
  }
  return {
    init: n,
    event: d,
    setUser: o,
    setSchoolType: a,
    getState: () => t,
    reset: s
  };
}
let c = null;
const U = {
  init: (t) => {
    if (c) {
      console.warn(`analytics already initialized (${c.getState().appName})`);
      return;
    }
    try {
      c = j(), c.init(t);
    } catch (e) {
      console.error("Can't init Google analytics", e), c = null;
    }
  },
  reset: () => {
    c && (c.reset(), c = null);
  },
  event: (t) => {
    c && c.event(t);
  },
  setUser: (t) => {
    c && c.setUser(t);
  },
  setSchoolType: (t) => {
    c && c.setSchoolType(t);
  },
  getState: () => (c == null ? void 0 : c.getState()) || b(),
  getInstance: () => c,
  setInstance: (t) => {
    if (!t)
      return;
    const e = t.getState();
    e.trace && console.log(`analytics setInstance ${e.appName}`), c = t;
  }
};
export {
  U as analytics,
  E as getEnvironment
};
//# sourceMappingURL=index.js.map
